var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (artworkColumns, className, hasAuctionPartner, imageUrl, isAuction, size, tall, undefined) {
jade_mixins["artworkItemTemplate"] = jade_interp = function(artwork, size){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if ( isAuction || artwork.get('sale'))
{
size = size || tall
imageUrl = artwork.defaultImageUrl(size) ? artwork.defaultImageUrl(size) : artwork.get('image').url
buf.push("<div class=\"artwork-columns-artwork\"><a" + (jade.attr("href", '/artwork/' + artwork.get('id'), true, true)) + "><img" + (jade.attr("src", imageUrl, true, true)) + (jade.attr("data-id", artwork.get('_id'), true, true)) + "></a><div class=\"artwork-columns-artwork-details\">");
if ( artwork.get('sale_artwork') && artwork.get('sale_artwork').lot_label)
{
buf.push("<p class=\"artwork-columns-artwork-details__auction-lot-number\">Lot " + (jade.escape((jade_interp = artwork.get('sale_artwork').lot_label) == null ? '' : jade_interp)) + "</p>");
}
if ( artwork.get('artist'))
{
buf.push("<p>" + (jade.escape(null == (jade_interp = artwork.get('artist').name) ? "" : jade_interp)) + "</p>");
}
buf.push("<p><em>" + (jade.escape(null == (jade_interp = artwork.get('title')) ? "" : jade_interp)) + "</em>");
if ( artwork.get('date'))
{
buf.push("," + (jade.escape(null == (jade_interp = artwork.get('date')) ? "" : jade_interp)));
}
buf.push("<p>" + (jade.escape(null == (jade_interp = artwork.partnerName()) ? "" : jade_interp)) + "</p></p><div class=\"artwork-columns-artwork-details__bid-now\"><p class=\"bid-now-link\">Bid now</p></div></div></div>");
}
else
{
size = size || tall
imageUrl = artwork.get('image') ? artwork.get('image').url : null
imageUrl = artwork.defaultImageUrl(size) ? artwork.defaultImageUrl(size) : imageUrl
hasAuctionPartner = (artwork.get('partner') && (artwork.get('partner').type === 'Auction' || artwork.get('partner').type === 'Auction House'))
buf.push("<div class=\"artwork-columns-artwork\"><a" + (jade.attr("href", '/artwork/' + artwork.get('id'), true, true)) + "><img" + (jade.attr("src", imageUrl, true, true)) + (jade.attr("data-id", artwork.get('_id'), true, true)) + "></a><div class=\"artwork-columns-artwork-details\">");
if ( artwork.get('artist'))
{
buf.push("<p>" + (jade.escape(null == (jade_interp = artwork.get('artist').name) ? "" : jade_interp)) + "</p>");
}
buf.push("<p><em>" + (jade.escape(null == (jade_interp = artwork.get('title')) ? "" : jade_interp)) + "</em>");
if ( artwork.get('date'))
{
buf.push(",&nbsp" + (jade.escape(null == (jade_interp = artwork.get('date')) ? "" : jade_interp)));
}
buf.push("</p><p>" + (jade.escape(null == (jade_interp = artwork.partnerName()) ? "" : jade_interp)) + "</p>");
if ( artwork.get('availability') === 'on hold')
{
if ( artwork.get('price'))
{
buf.push("<p>" + (jade.escape((jade_interp = artwork.get('price')) == null ? '' : jade_interp)) + ", on hold</p>");
}
else
{
buf.push("<p>On hold</p>");
}
}
else if ( artwork.get('sale_message') && artwork.get('sale_message').indexOf('Sold') > -1)
{
buf.push("<p>Sold</p>");
}
else if ( artwork.get('availability') !== 'not for sale')
{
buf.push("<p>" + (jade.escape(null == (jade_interp = artwork.saleMessage()) ? "" : jade_interp)) + "</p>");
}
if ( hasAuctionPartner)
{
buf.push("<div class=\"artwork-columns-artwork-details__bid-now\">");
if ( artwork.get('forsale') || artwork.get('is_for_sale'))
{
buf.push("<p class=\"bid-now-link\">Bid now</p>");
}
else
{
buf.push("<p class=\"bid-now-link\">Auction closed</p>");
}
buf.push("</div>");
}
if ( artwork.get('inquireable') && !hasAuctionPartner)
{
buf.push("<a" + (jade.attr("href", '/artwork/' + artwork.get('id'), true, true)) + ">Contact Gallery</a>");
}
buf.push("</div></div>");
}
};
size = 'tall'
className = 'artwork-columns'
switch (artworkColumns.length){
case 3:
className = "artwork-columns artwork-columns-triple"
  break;
case 2:
className = "artwork-columns artwork-columns-double"
  break;
default:
className = "artwork-columns artwork-columns-single"
size = 'large'
  break;
}
buf.push("<div" + (jade.cls([className], [true])) + ">");
// iterate artworkColumns
;(function(){
  var $$obj = artworkColumns;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var column = $$obj[$index];

buf.push("<div class=\"artwork-columns-column\">");
// iterate column
;(function(){
  var $$obj = column;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var artwork = $$obj[$index];

jade_mixins["artworkItemTemplate"](artwork, size);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var artwork = $$obj[$index];

jade_mixins["artworkItemTemplate"](artwork, size);
    }

  }
}).call(this);

buf.push("</div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var column = $$obj[$index];

buf.push("<div class=\"artwork-columns-column\">");
// iterate column
;(function(){
  var $$obj = column;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var artwork = $$obj[$index];

jade_mixins["artworkItemTemplate"](artwork, size);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var artwork = $$obj[$index];

jade_mixins["artworkItemTemplate"](artwork, size);
    }

  }
}).call(this);

buf.push("</div>");
    }

  }
}).call(this);

buf.push("</div>");}.call(this,"artworkColumns" in locals_for_with?locals_for_with.artworkColumns:typeof artworkColumns!=="undefined"?artworkColumns:undefined,"className" in locals_for_with?locals_for_with.className:typeof className!=="undefined"?className:undefined,"hasAuctionPartner" in locals_for_with?locals_for_with.hasAuctionPartner:typeof hasAuctionPartner!=="undefined"?hasAuctionPartner:undefined,"imageUrl" in locals_for_with?locals_for_with.imageUrl:typeof imageUrl!=="undefined"?imageUrl:undefined,"isAuction" in locals_for_with?locals_for_with.isAuction:typeof isAuction!=="undefined"?isAuction:undefined,"size" in locals_for_with?locals_for_with.size:typeof size!=="undefined"?size:undefined,"tall" in locals_for_with?locals_for_with.tall:typeof tall!=="undefined"?tall:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;